// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n  --color-primary: #0D2B42;\n  --color-secondary: #063F78;\n  --color-terceira: #28A1DC;\n  --color-registrar: #063F78;\n  --color-branco: #f1f3f5;\n  --color-button: #0D2B42;\n  --color-confirmar: #d0d1d4;\n  --color-modal: #0D2B42;\n  --color-box: #616163;\n  --color-box-status-green: #65cb81;\n  --color-box-status-red: #d70916;\n}\n\n#root {\n  height: 100% !important;\n  min-height: 100vh !important;\n}", ""]);
// Exports
module.exports = exports;
